import { useState, useEffect, React } from "react";
import $ from 'jquery';
// core components
import './Involved.css';
import Footer from "../Footer/Footer.js";
import Loader from "../../components/loader/loader.js";
import About from "../../assets/images/about.png"
import Volunteer from "../../assets/images/volunteer.png"
import Education from "../../assets/images/Education.png"
import Supportmission from "../../assets/images/supportmission.png"
import Adopt from "../../assets/images/adopt.png"
import Health from "../../assets/images/Health.png"
import Public from "../../assets/images/Public.png"
import {Link} from "react-router-dom";

export default function Home() {
   const [loading, setLoading] = useState(true);
 
   useEffect(() => {
     const timer = setTimeout(() => {
       setLoading(false);
     }, 2500); 
 
     return () => clearTimeout(timer);
   }, []);
   $(window).scroll(function () {
    if ($(this).scrollTop()) {
      $('header').addClass('fixedTop');
    } else {
      $('header').removeClass('fixedTop');
    }
  });
  useEffect(() => {
     window.scrollTo(0, 0)
   }, [])
  return (
<div>
{loading ? <Loader /> :
    <div>
        <div className="vision_header">
          <section className="vision_banner">
            <div className="container-fluid custom-container">
               <div className="row">
                  <div className="col-md-6 col-sm-12 col-12">
                     <div className="vision_banner_text">
                        <h1>Get Involved</h1>
                       </div>
                  </div>
                  <div className="col-md-6 col-sm-12 col-12">
                     <div className="vision_banner_img">
                     <img src={About} alt="about" className="img-fluid"/>
                     </div>
                  </div>
               </div>
               </div>
            
                  
            </section>
           
            <section className="Involved mt-4 pt-5">
               <div className="container-fluid custom-container">
                  <div className="Involved_text">
                     <h2>Get Involved</h2>
                     <p>Every step, big or small, has the power to transform lives.</p>
                     <div className="get_involed_inner">
                       
                           <div className="getinvolved_text">
                              <img src={Volunteer} alt="volunteer" className="img-fluid"/>
                              <h2>Volunteer  with  Us</h2>
                             <h3>Your presence, time, and skills can light up someone’s path.</h3>
                             <h4><i>“Volunteering adds value not only to their life—but to yours as well.”</i></h4>

                           </div>
                       
                          <div className="getinvolved_text">
                              <img src={Supportmission} alt="Supportmission" className="img-fluid"/>
                              <h2>Supporting the Elderly</h2>
                               <p>Your donations help us:</p>
                              <ul>
                                 <li>Educate and empower the visually impaired</li>
                                 <li>Provide essential assistive devices</li>
                                 <li>Run wellness and medical outreach programs</li>
                              </ul>
                           </div>
                        
                        <div className="getinvolved_text">
                              <img src={Volunteer} alt="volunteer" className="img-fluid"/>
                              <h2>Partner with Us</h2>
                             <h3>We collaborate with educational institutions, tech companies, healthcare providers, and NGOs. Together, let’s create sustainable, inclusive change.</h3>
                           

                           </div>
                          
                        
                        
                     </div>
                  </div>
               </div>
               </section>
                  
           <Footer />
        </div>
     
    </div>
    }
    </div>
  )
}
